import { Pipe, PipeTransform } from '@angular/core'

export interface HighlightSegment {
  text: string
  isMatch: boolean
}

// Splits text into segments around case-insensitive occurrences of the search term,
// so the template can highlight matching portions (similar to seg-common/seg-unique pattern).
@Pipe({
  name: 'highlightSearch',
  standalone: false,
  pure: true,
})
export class HighlightSearchPipe implements PipeTransform {
  transform(text: string, search: string): HighlightSegment[] {
    if (!text || !search) return [{ text: text || '', isMatch: false }]

    const escaped = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    const regex = new RegExp(`(${escaped})`, 'gi')
    const parts = text.split(regex)

    return parts
      .filter((p) => p.length > 0)
      .map((p) => ({ text: p, isMatch: p.toLowerCase() === search.toLowerCase() }))
  }
}
